<div class="space-y-4">
  <!-- Aviso de confidencialidad -->
  <p class="text-xs text-gray-500 dark:text-gray-400">
    Notas internas de uso administrativo. Visibles solo para el equipo interno; nunca se muestran al cliente.
  </p>

  <!-- Composer: crear o editar -->
  <div class="rounded-lg border border-gray-200 dark:border-gray-700 p-3">
    <textarea
      [(ngModel)]="draftContent"
      rows="3"
      [maxlength]="maxContent"
      [placeholder]="isEditing ? 'Edita la nota…' : 'Escribe una nota interna…'"
      class="w-full resize-y rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm text-gray-800 dark:text-gray-100 focus:border-brand-500 focus:outline-none"
    ></textarea>
    <div class="mt-2 flex items-center justify-between">
      <span class="text-xs text-gray-400">{{ contentLength }}/{{ maxContent }}</span>
      <div class="flex items-center gap-2">
        @if (isEditing) {
          <button type="button" (click)="cancelEdit()"
            class="rounded-md px-3 py-1.5 text-sm text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700">
            Cancelar
          </button>
        }
        <button type="button" (click)="submit()" [disabled]="saving || !draftContent.trim()"
          class="rounded-md bg-brand-500 px-3 py-1.5 text-sm font-medium text-white hover:bg-brand-600 disabled:opacity-50">
          {{ isEditing ? 'Guardar cambios' : 'Agregar nota' }}
        </button>
      </div>
    </div>
  </div>

  <!-- Estados -->
  @if (loading) {
    <p class="text-sm text-gray-500 dark:text-gray-400">Cargando notas…</p>
  } @else if (loadError) {
    <p class="text-sm text-error-500">{{ loadError }}</p>
  } @else if (notes.length === 0) {
    <p class="text-sm text-gray-500 dark:text-gray-400">Aún no hay notas internas para este producto.</p>
  } @else {
    <ul class="space-y-3">
      @for (note of notes; track note.id) {
        <li class="rounded-lg border border-gray-200 dark:border-gray-700 p-3">
          <div class="flex items-start gap-3">
            <div class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand-100 text-xs font-semibold text-brand-600 dark:bg-brand-500/20 dark:text-brand-300">
              {{ authorInitials(note) }}
            </div>
            <div class="min-w-0 flex-1">
              <div class="flex flex-wrap items-center gap-x-2 gap-y-0.5">
                <span class="text-sm font-medium text-gray-800 dark:text-gray-100">{{ authorLabel(note) }}</span>
                <span class="text-xs text-gray-400">{{ formatDateTime(note.datetimeCreated) }}</span>
                @if (wasEdited(note)) {
                  <span class="text-xs italic text-gray-400">(editado {{ formatDateTime(note.datetimeUpdated) }})</span>
                }
              </div>
              <p class="mt-1 whitespace-pre-wrap break-words text-sm text-gray-700 dark:text-gray-200">{{ note.content }}</p>

              @if (isAuthor(note)) {
                <div class="mt-2 flex items-center gap-3">
                  <button type="button" (click)="startEdit(note)"
                    class="text-xs font-medium text-brand-600 hover:underline dark:text-brand-400">
                    Editar
                  </button>
                  <button type="button" (click)="eliminar(note)" [disabled]="isDeleting(note)"
                    class="text-xs font-medium text-error-500 hover:underline disabled:opacity-50">
                    Eliminar
                  </button>
                </div>
              }
            </div>
          </div>
        </li>
      }
    </ul>
  }
</div>
